// src/routes/ProtectedRoute.tsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { JSX } from "react";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isAuthenticated, setRedirectUrl, showAdminPanel } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    setRedirectUrl(location.pathname);
    return <Navigate to="/login" />;
  }

  if (showAdminPanel && !location.pathname.startsWith("/admin")) {
    return <Navigate to="/admin" />;
  }
  if (!showAdminPanel && location.pathname.startsWith("/admin")) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
